<script>
export default {
    name: 'IlluCours10jours',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-cours10jours"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <circle
                :stroke="secondaryColor"
                class="secondary-color"
                cx="39"
                cy="32"
                r="15.5"
            />
            <path
                d="M47.243 23.515l1.414 1.414L41 32.586l.828.828-1.414 1.414-.828-.828-.829.828-1.414-1.414.829-.828-6.243-6.243 1.414-1.414 6.243 6.243 7.657-7.657z"
                :fill="primaryColor"
                class="primary-color"
            />
            <path
                :stroke="secondaryColor"
                class="secondary-color"
                stroke-linecap="round"
                d="M11 32h10M16 24h6M9 40h10"
            />
        </g>
    </svg>
</template>
